<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Settings</h1>
    </header>
    <form id="modal-body">
        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Select Paper Size</mat-label>
                <mat-select (selectionChange)="changePaper($event.value)" formControlName="paperType">
                  <mat-option i18n *ngFor="let type of types" [value]="type">{{type}}</mat-option>
                </mat-select>
            </mat-form-field>     
                   
        </form>
        <form class="row">
            <mat-form-field class="col-6">
              <mat-label i18n>Width</mat-label>
              <input matInput placeholder="20000" [(ngModel)]="width" name="width" autocomplete="off" [disabled]="isDisabled">
            </mat-form-field>
          
            <mat-form-field class="col-6">
              <mat-label i18n>Height</mat-label>
              <input matInput placeholder="14000" [(ngModel)]="height" name="height" autocomplete="off" [disabled]="isDisabled">
            </mat-form-field>
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Select Node Opacity</mat-label>
                <mat-select  formControlName="selectedNodeOpacity">
                  <mat-option i18n *ngFor="let opacity of opacities" [value]="opacity.value">{{opacity.label}}</mat-option>
                </mat-select>
            </mat-form-field>     
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Select Background Opacity</mat-label>
                <mat-select  formControlName="selectedOpacity">
                  <mat-option i18n *ngFor="let opacity of opacities" [value]="opacity.value">{{opacity.label}}</mat-option>
                </mat-select>
            </mat-form-field>         
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field class="col-6">
                <mat-label i18n>Border Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker" autocomplete='false' formControlName="borderColor">
                <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker  [color]="color"></ngx-mat-color-picker>
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label i18n>Border Width</mat-label>
                <input matInput placeholder="1" type="number" min= '0' formControlName="borderWidth">
            </mat-form-field>
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field class="col-6">
                <mat-label i18n>Male Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker1" autocomplete='false' formControlName="maleColor">
                <ngx-mat-color-toggle matSuffix [for]="picker1"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker1  [color]="color"></ngx-mat-color-picker>
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label i18n>Female Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker2" autocomplete='false' formControlName="femaleColor">
                <ngx-mat-color-toggle matSuffix [for]="picker2"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker2 [color]="color"></ngx-mat-color-picker>
            </mat-form-field>
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field class="col-6">
                <mat-label i18n>Male Node Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker3" autocomplete='false' formControlName="maleNodeColor">
                <ngx-mat-color-toggle matSuffix [for]="picker3"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker3 [color]="color"></ngx-mat-color-picker>
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label i18n>Female Node Color</mat-label>
                <input matInput [ngxMatColorPicker]="picker4" autocomplete='false' formControlName="femaleNodeColor">
                <ngx-mat-color-toggle matSuffix [for]="picker4"></ngx-mat-color-toggle>
                <ngx-mat-color-picker #picker4 [color]="color"></ngx-mat-color-picker>
            </mat-form-field>
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field class="col-6">
                <mat-label i18n>Max Generation</mat-label>
                <input matInput placeholder="10"  type="number" min= '1' formControlName="maxGeneration">
            </mat-form-field>
            <mat-form-field class="col-6">
                <mat-label i18n>Corner Round</mat-label>
                <input matInput placeholder="50" type="number" min= '1' formControlName="cornerRound">
            </mat-form-field>
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Name Align Setting</mat-label>
                <mat-select formControlName="name_text_align">
                  <mat-option i18n value="middle">Center</mat-option>
                  <mat-option i18n value="start">Left</mat-option>
                  <mat-option i18n value="end">Right</mat-option>
                </mat-select>
            </mat-form-field>  
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Other Align Setting</mat-label>
                <mat-select formControlName="text_align">
                  <mat-option i18n value="middle">Center</mat-option>
                  <mat-option i18n value="start">Left</mat-option>
                  <mat-option i18n value="end">Right</mat-option>
                </mat-select>
            </mat-form-field>  
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Empty Node Setting</mat-label>
                <mat-select formControlName="empty_node_setting">
                  <mat-option i18n value="block">SHOW</mat-option>
                  <mat-option i18n value="none">HIDE</mat-option>
                </mat-select>
            </mat-form-field>  
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Birth Info Setting</mat-label>
                <mat-select formControlName="birth_info_setting">
                  <mat-option i18n value="block">SHOW</mat-option>
                  <mat-option i18n value="none">HIDE</mat-option>
                  <mat-option i18n value="hide">HIDE EMPTY</mat-option>
                </mat-select>
            </mat-form-field>              
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Marriage Info Setting</mat-label>
                <mat-select formControlName="marriage_info_setting">
                  <mat-option i18n value="block">SHOW</mat-option>
                  <mat-option i18n value="none">HIDE</mat-option>
                  <mat-option i18n value="hide">HIDE EMPTY</mat-option>
                </mat-select>
            </mat-form-field>       
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Death Info Setting</mat-label>
                <mat-select formControlName="death_info_setting">
                  <mat-option i18n value="block">SHOW</mat-option>
                  <mat-option i18n value="none">HIDE</mat-option>
                  <mat-option i18n value="hide">HIDE EMPTY</mat-option>
                </mat-select>
            </mat-form-field>       
        </form>

        <form class="row" [formGroup]="paper">
            <mat-form-field appearance="fill" class="col-6" *ngIf="tree_type=='single'">
                <mat-label i18n>Wife/Husband Visibility</mat-label>
                <mat-select formControlName="partner_setting">
                  <mat-option i18n value="SHOW">SHOW</mat-option>
                  <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>       
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Children Visibility</mat-label>
                <mat-select formControlName="children_setting">
                  <mat-option i18n value="SHOW">SHOW</mat-option>
                  <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>       
        </form>
        <form class="row" [formGroup]="paper">   
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Flag Visibility</mat-label>
                <mat-select formControlName="flag_setting">
                  <mat-option i18n value="SHOW">SHOW</mat-option>
                  <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>     
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Profile Visibility</mat-label>
                <mat-select formControlName="profile_setting">
                  <mat-option i18n value="SHOW">SHOW</mat-option>
                  <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>     
        </form>

        <form class="row" [formGroup]="paper">   
            <mat-form-field class="col-6">
                <mat-label i18n>Global Padding</mat-label>
                <input matInput placeholder="5" type="number" min= '0' formControlName="global_padding">
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Warning Visibility</mat-label>
                <mat-select formControlName="warning_setting">
                  <mat-option i18n value="SHOW">SHOW</mat-option>
                  <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>  
        </form>

    </form>
    <footer id="modal-footer">
        <button i18n mat-raised-button (click)="setRecommendedSettings()">Set recommended settings</button>
        <div>
            <button i18n mat-raised-button id="modal-action-button" (click)="actionFunction()">
                Save
            </button>
            <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
                Close
            </button>
        </div>
    </footer>
</div>